export default 
[
    {
    id:2,
    title: 'Practical Scenario 2 - Four-layer structure for TCP/IP protocols',
    description: 'Students found it difficult to visualise the interaction between the client and server during a secure HTTPS connection.By following simple HCI Design Cycle trying to indentify the current approaches starting from  Version_1 to proposed Version 4. Trying to find out which interaction helps students understand the concept most effectively. ',
   },
  
     {
    id:1,
    title: 'Practical Scenario 1 -Introducing Object-Oriented Analysis using Simple Object Diagrams',
    description: 'Students often struggle to identify objects before writing code.The circle-and-arrow representation reduces the complexity of formal UML while encouraging students to reason about relationships, communication, and dependencies between objects. The informal notation acts as a cognitive bridge between the problem domain (the game) and the software design domain (UML and object-oriented programming).',
   }
 



]